export default "__VITE_ASSET__9292fca6__"